var stepDefaults = {
  classes: 'shepherd-theme-arrows',
  scrollTo: true
}

var EmployeeProfileTour = new Shepherd.Tour({
  defaults: stepDefaults
})

EmployeeProfileTour.addStep('overview', {
  text: 'This is a personal employee\'s profile in Shift Agent. Settings relating to a single employee can be viewed and edited here.',
  buttons: [{
    text: 'Next',
    action: 'next'
  }]
})

EmployeeProfileTour.addStep('tab-layout', {
  text: 'The employee profile has a set of tabs that contain various functionalities.',
  attachTo: '.nav.nav-tabs bottom',
  tetherOptions: {
    offset: '-25px 0'
  },
  buttons: [{
    text: 'Prev',
    action: 'previous'
  }, {
    text: 'Next',
    action: 'next'
  }]
})

var temp = new Shepherd.Step(EmployeeProfileTour, lodash.extend({
  id: 'dashboard-tab',
  text: 'Every employee has a dashboard that displays the nearest upcoming shifts and a brief summary of their recent days off requests.',
  attachTo: '.employee-profile-primary',
  buttons: [{
    text: 'Prev',
    action: 'previous'
  }, {
    text: 'Next',
    action: 'next'
  }],
  tetherOptions: {
    attachment: 'center right',
    targetAttachment: 'center left',
  },
  extraStyles: {
    'background-color': '#e3e3e3',
    'border-radius': '0',
    'padding': '0',
    'transform': 'none'
  }
}, stepDefaults))

temp.on('show', function () {
  var scope = angular.element(document).scope();
  scope.$apply(scope.$broadcast('sa:employeeProfile:switchTab', 0));
})
EmployeeProfileTour.addStep(temp)

temp = new Shepherd.Step(EmployeeProfileTour, lodash.extend({
  id: 'information-tab',
  text: 'The information tab displays a few pieces of basic information about an employee including contact information, name, and date of birth.',
  attachTo: '.employee-profile-primary',
  buttons: [{
    text: 'Prev',
    action: 'previous'
  }, {
    text: 'Next',
    action: 'next'
  }],
  tetherOptions: {
    attachment: 'center right',
    targetAttachment: 'center left'
  },
  extraStyles: {
    'background-color': '#e3e3e3',
    'border-radius': '0',
    'padding': '0',
    'transform': 'none'
  }
}, stepDefaults))

temp.on('show', function () {
  var scope = angular.element(document).scope();
  scope.$apply(scope.$broadcast('sa:employeeProfile:switchTab', 1));
})
EmployeeProfileTour.addStep(temp)

temp = new Shepherd.Step(EmployeeProfileTour, lodash.extend({
  id: 'pay-rates-tab',
  text: 'Only admins can see the Pay Rates tab. From here you can add, remove, and edit the pay rate exceptions for this employee.',
  attachTo: '.employee-profile-primary',
  buttons: [{
    text: 'Prev',
    action: 'previous'
  }, {
    text: 'Next',
    action: 'next'
  }],
  tetherOptions: {
    attachment: 'center right',
    targetAttachment: 'center left'
  },
  extraStyles: {
    'background-color': '#e3e3e3',
    'border-radius': '0',
    'padding': '0',
    'transform': 'none'
  }
}, stepDefaults))

temp.on('show', function () {
  var scope = angular.element(document).scope();
  scope.$apply(scope.$broadcast('sa:employeeProfile:switchTab', 2));
})

EmployeeProfileTour.addStep(temp)

temp = new Shepherd.Step(EmployeeProfileTour, lodash.extend({
  id: 'positions-tab',
  text: 'Only admins and managers can see this tab. Using this tab, you can assign positions to this employee and give them a skill level.',
  attachTo: '.employee-profile-primary',
  buttons: [{
    text: 'Prev',
    action: 'previous'
  }, {
    text: 'Next',
    action: 'next'
  }],
  tetherOptions: {
    attachment: 'center right',
    targetAttachment: 'center left'
  },
  extraStyles: {
    'background-color': '#e3e3e3',
    'border-radius': '0',
    'padding': '0',
    'transform': 'none'
  }
}, stepDefaults))

temp.on('show', function () {
  var scope = angular.element(document).scope();
  scope.$apply(scope.$broadcast('sa:employeeProfile:switchTab', 3));
})

EmployeeProfileTour.addStep(temp)

temp = new Shepherd.Step(EmployeeProfileTour, lodash.extend({
  id: 'days-off-tab',
  text: 'A full report of all of the requests for time off an employee has made in the past 6 months is available on the days off tab. Only admins are allowed to view this information.',
  attachTo: '.employee-profile-primary',
  buttons: [{
    text: 'Prev',
    action: 'previous'
  }, {
    text: 'Next',
    action: 'next'
  }],
  tetherOptions: {
    attachment: 'center right',
    targetAttachment: 'center left'
  },
  extraStyles: {
    'background-color': '#e3e3e3',
    'border-radius': '0',
    'padding': '0',
    'transform': 'none'
  }
}, stepDefaults))

temp.on('show', function () {
  var scope = angular.element(document).scope();
  scope.$apply(scope.$broadcast('sa:employeeProfile:switchTab', 4));
})

EmployeeProfileTour.addStep(temp)

temp = new Shepherd.Step(EmployeeProfileTour, lodash.extend({
  id: 'availability-tab',
  text: 'Just like the previous tab, only admins are allowed to view the Availability tab. From here a brief summary of this employee\'s recent availability action can be seen.',
  attachTo: '.employee-profile-primary',
  buttons: [{
    text: 'Prev',
    action: 'previous'
  }, {
    text: 'Next',
    action: 'next'
  }],
  tetherOptions: {
    attachment: 'center right',
    targetAttachment: 'center left'
  },
  extraStyles: {
    'background-color': '#e3e3e3',
    'border-radius': '0',
    'padding': '0',
    'transform': 'none'
  }
}, stepDefaults))

temp.on('show', function () {
  var scope = angular.element(document).scope()
  scope.$apply(scope.$broadcast('sa:employeeProfile:switchTab', 5))
})

temp = new Shepherd.Step(EmployeeProfileTour, lodash.extend({
  id: 'notes-tab',
  text: 'The Notes tab contains all of the SmartNotes that have been attached to this user. You can leave notes for or about this employee that are public or even private.',
  attachTo: '.employee-profile-primary',
  buttons: [{
    text: 'Prev',
    action: 'previous'
  }, {
    text: 'Next',
    action: 'next'
  }],
  tetherOptions: {
    attachment: 'center right',
    targetAttachment: 'center left'
  },
  extraStyles: {
    'background-color': '#e3e3e3',
    'border-radius': '0',
    'padding': '0',
    'transform': 'none'
  }
}, stepDefaults))

temp.on('show', function () {
  var scope = angular.element(document).scope()
  scope.$apply(scope.$broadcast('sa:employeeProfile:switchTab', 6))
})

temp = new Shepherd.Step(EmployeeProfileTour, lodash.extend({
  id: 'settings-tab',
  text: 'The final tab available contains a few personal settings for the employees to edit as well as an area for you to change their permission level.',
  attachTo: '.employee-profile-primary',
  buttons: [{
    text: 'Prev',
    action: 'previous'
  }, {
    text: 'Next',
    action: 'next'
  }],
  tetherOptions: {
    attachment: 'center right',
    targetAttachment: 'center left'
  },
  extraStyles: {
    'background-color': '#e3e3e3',
    'border-radius': '0',
    'padding': '0',
    'transform': 'none'
  }
}, stepDefaults))

temp.on('show', function () {
  var scope = angular.element(document).scope()
  scope.$apply(scope.$broadcast('sa:employeeProfile:switchTab', 7))
})

temp.on('hide', function () {
  var scope = angular.element(document).scope()
  scope.$apply(scope.$broadcast('sa:employeeProfile:switchTab', 0))
})

EmployeeProfileTour.addStep(temp)

EmployeeProfileTour.addStep('conclusion', {
  text: 'This concludes our tour of the employee profile! We hope you enjoy using Shift Agent and if you have any questions or concerns, don\'t hesitate to contact us.',
  buttons: [{
    text: 'Prev',
    action: 'previous'
  }, {
    text: 'Finish',
    action: 'finish'
  }]
})